import { COACH_MARKETPLACE_PAGE } from 'constants/pages';
import { MyCoachesProps } from 'screens/PlayerLoggedInScreen/props';
import CardsSection from 'components/CardSection';
import CoachAvatar from './CoachAvatar';
import EmptyState from '../EmptyState';
import IconActionLink from 'components/IconActionLink';

const MyCoaches: React.FC<MyCoachesProps> = ({ coaches, loading, handleBookLessonWithCoach }) => {
  return (
    <>
      <div className="container mx-auto mt-[1.6rem] border-b border-color-bg-input-lightmode-primary pb-ds-2xl dark:border-color-bg-input-darkmode-primary max-sm:pl-4">
        <h3 className="typography-product-heading-desktop max-sm:typography-product-heading-mobile mb-5 max-sm:mb-3">
          My Coaches
        </h3>

        {!loading && coaches.length === 0 && (
          <EmptyState
            href={COACH_MARKETPLACE_PAGE}
            title="Find new Coach"
            text="You don’t have Coaches you follow yet."
          />
        )}

        <CardsSection
          loading={loading}
          scrollOffset={{
            base: 0,
            xs: 100,
            lg: 0,
          }}
          visibleCards={{
            base: 1,
            xs: 2,
            md: 5,
            lg: 7,
            xxl: 8,
          }}
          gap="1rem"
          data={coaches}
          renderCard={(coach) => (
            <CoachAvatar key={coach.id} coach={coach} onBook={handleBookLessonWithCoach} />
          )}
          affix={<IconActionLink title="Find new Coach" href={COACH_MARKETPLACE_PAGE} />}
        />
      </div>
    </>
  );
};
export default MyCoaches;
